import { render, staticRenderFns } from "./NavbarDesktop.vue?vue&type=template&id=aef348b2"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavbarDesktop.vue?vue&type=style&index=0&id=aef348b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports